import Scheduling from './Scheduling';

export default Scheduling;